import React from 'react'
import { Edit } from 'react-admin'
import WithDeleteModalToolbar from 'ui-shared/CustomToolbars/WithDeleteModalToolbar'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import LocationFeatureForm from './LocationFeatureForm'

const LocationFeatureEdit: React.FC = () => {
  return (
    <SectionWrapper>
      <Edit>
        <LocationFeatureForm toolbar={<WithDeleteModalToolbar />} />
      </Edit>
    </SectionWrapper>
  )
}

export default LocationFeatureEdit
